import Title from '../../@iosper/components/Page/Title';
import { ProtesisMain } from '../pages';

export const Protesis = () => {
  return (
    <>
      <Title autoFocus={false}>Prótesis</Title>
      <ProtesisMain />
    </>
  );
};
